import AxiosService from "./AxiosService";

export default class SpecificAPI {
  static getUsers = (filter) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/users";

      AxiosService.get(url, filter, null)
        .then((result) => {
          const data = result.data || [];
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getSummaryMessage = (school_id, history_id) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/statistics/history-summary/${school_id}/${history_id}`;

      AxiosService.get(url, null, null)
        .then((result) => {
          const data = result.data || {};
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getAllUsers = async (filters = {}, perPage = 100) => {
    let page = 1;
    let allUsers = [];
    let hasMore = true;

    while (hasMore) {
      const result = await AxiosService.get("/api/users", {
        page,
        per_page: perPage,
        ...filters,
      });

      const users = result.data?.data || result.data || [];
      const meta = result.data?.meta;

      allUsers = [...allUsers, ...users];

      if (!meta) {
        hasMore = users.length === perPage;
      } else {
        hasMore = meta.current_page < meta.total_pages;
      }

      page++;
    }

    return allUsers;
  };

  static getAllWallets = async (filters = {}, perPage = 100) => {
    let page = 1;
    let allUsersWallets = [];
    let hasMore = true;

    while (hasMore) {
      const result = await AxiosService.get("/api/wallet", {
        page,
        per_page: perPage,
        ...filters,
      });

      const wallets = result.data?.data || result.data || [];
      const meta = result.data?.meta;

      allUsersWallets = [...allUsersWallets, ...wallets];

      if (!meta) {
        hasMore = wallets.length === perPage;
      } else {
        hasMore = meta.current_page < meta.total_pages;
      }

      page++;
    }

    return allUsersWallets;
  };

  static createWalletRecord = (walletRecord) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/wallet";

      AxiosService.post(url, null, walletRecord, null, true)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static updateWalletRecordByRole = (school_id, role, credit_available) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/wallet/edit-by-role/${school_id}/${role}`;

      AxiosService.put(url, null, { credit_available }, null, true)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static updateUserPolicyConfirmation = (userId) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/user_policies_confirmation/" + userId;

      AxiosService.put(url, null, null, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static updateWalletRecord = (walletRecord) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/wallet/" + walletRecord.id;

      AxiosService.put(url, null, walletRecord, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static createUser = (user) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/users";

      AxiosService.post(url, null, user, null, true)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static updateUser = (user_id, user) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/users/" + user_id;

      AxiosService.put(url, null, user, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static deleteUser = (id) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/users/" + id;
      AxiosService.delete(url, null, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getOrganizations = (filter) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/school";

      AxiosService.get(url, { ...filter, page: 1, per_page: 50 }, null)
        .then((result) => {
          const data = result.data || [];
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static createOrganization = (organization) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/school";

      AxiosService.post(url, null, organization, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static updateOrganization = (organization) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/school/" + organization.id;

      AxiosService.put(url, null, organization, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static deleteOrganization = (id) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/school/" + id;
      AxiosService.delete(url, null, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getModules = (filter) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/module";

      AxiosService.get(url, { ...filter, page: 1, per_page: 50 }, null)
        .then((result) => {
          const data = result.data || [];
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getDepartments = (filter, schoolId) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/department/${schoolId}`;
      const params = { ...filter, page: 1, per_page: 50 };

      AxiosService.get(url, params, null)
        .then((result) => {
          const data = result.data || [];
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getPromptCategories = async (filter = {}) => {
    const url = "/api/prompt-category";
    const per_page = filter.per_page || 50;
    let allResults = [];
    let page = 1;
    let totalPages = 1;

    try {
      do {
        const params = { ...filter, page, per_page };
        const { data: responseData } = await AxiosService.get(url, params);

        // your API likely uses `data` for items
        const items = responseData?.data || [];
        allResults.push(...items);

        // detect total pages from `last_page`
        if (page === 1) totalPages = responseData.last_page || 1;

        page++;
      } while (page <= totalPages);

      return allResults;
    } catch (err) {
      console.error("Error fetching prompt categories:", err);
      throw err;
    }
  };

  static getAllPrompts = async (filter = {}) => {
    const url = "/api/prompt";
    const per_page = filter.per_page || 50;
    let allResults = [];
    let page = 1;
    let totalPages = 1;

    do {
      const params = { ...filter, page, per_page };
      const { data: responseData } = await AxiosService.get(url, params);

      const items = responseData?.data || [];
      allResults.push(...items);

      if (page === 1) totalPages = responseData.last_page || 1;

      page++;
    } while (page <= totalPages);

    return allResults;
  };

  static sendPasswordReset = (email) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/auth0/users/send-password-reset-email";

      AxiosService.post(url, null, { email }, null, true)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getUserRights = (filter) => {
    return new Promise(function (resolve, reject) {
      //     var url = "/api/prompt";

      //     AxiosService.get(url, filter, null)
      //         .then((result) => {
      //             const data = result.data || [];
      //             resolve(data);
      //         })
      //         .catch((error) => {
      //             reject(error);
      //         })
      resolve({
        data: {
          schools: {
            create: ["6915f82557b7d9f51ffbc384"],
            read: ["6915f82557b7d9f51ffbc384"],
            update: ["6915f82557b7d9f51ffbc384"],
            delete: ["6915f82557b7d9f51ffbc384"],
          },
          modules: {
            create: [
              "68dfcb2ed32100b760040da2",
              "68dfcb6d373342ba13041ae2",
              "68dfcbc48564db56450f14d2",
              "68dfcc155f7d06c326054092",
              "68dfcc34fec9c5bf210c3ce2",
              "68dfcc4cf60f1a6a17054cf2",
            ],
            read: ["68dfcc155f7d06c326054092", "68dfcc34fec9c5bf210c3ce2", "68dfcc4cf60f1a6a17054cf2"],
            update: ["68dfcc155f7d06c326054092", "68dfcc34fec9c5bf210c3ce2", "68dfcc4cf60f1a6a17054cf2"],
            delete: ["68dfcc155f7d06c326054092", "68dfcc34fec9c5bf210c3ce2", "68dfcc4cf60f1a6a17054cf2"],
          },
          prompt_categories: {
            create: [
              "68dfceb8ae245629700fec12",
              "68dfce073d1468e830050872",
              "68dfce36342e4da910064d52",
              "68dfce6cec58e09e2c023ab2",
            ],
            read: [
              "68dfceb8ae245629700fec12",
              "68dfce073d1468e830050872",
              "68dfce36342e4da910064d52",
              "68dfce6cec58e09e2c023ab2",
            ],
            update: [
              "68dfceb8ae245629700fec12",
              "68dfce073d1468e830050872",
              "68dfce36342e4da910064d52",
              "68dfce6cec58e09e2c023ab2",
            ],
            delete: [
              "68dfceb8ae245629700fec12",
              "68dfce073d1468e830050872",
              "68dfce36342e4da910064d52",
              "68dfce6cec58e09e2c023ab2",
            ],
          },
          prompts: {
            create: [
              "68dfd2c923d18ff3ea0307a2",
              "68dfd33749c4bf41860ef142",
              "68dfd0482dc1b7628a0ca492",
              "68dfd08b132dee6f9e06a052",
              "68dfd0b4e8741b8d560338b2",
              "68dfd0da7a9a1c12b5000ec2",
              "68dfd0120f9c5d585b02a4b2",
              "68dfd16842d6c519830c7602",
              "68dfd196298f38cac10e24f2",
            ],
            read: [
              "68dfd0482dc1b7628a0ca492",
              "68dfd08b132dee6f9e06a052",
              "68dfd0b4e8741b8d560338b2",
              "68dfd0da7a9a1c12b5000ec2",
              "68dfd2c923d18ff3ea0307a2",
              "68dfd33749c4bf41860ef142",
              "68dfd16842d6c519830c7602",
              "68dfd196298f38cac10e24f2",
              "68dfd0120f9c5d585b02a4b2",
            ],
            update: [
              "68dfd0482dc1b7628a0ca492",
              "68dfd08b132dee6f9e06a052",
              "68dfd0b4e8741b8d560338b2",
              "68dfd0da7a9a1c12b5000ec2",
              "68dfd2c923d18ff3ea0307a2",
              "68dfd33749c4bf41860ef142",
              "68dfd16842d6c519830c7602",
              "68dfd196298f38cac10e24f2",
              "68dfd0120f9c5d585b02a4b2",
            ],
            delete: [
              "68dfd0482dc1b7628a0ca492",
              "68dfd08b132dee6f9e06a052",
              "68dfd0b4e8741b8d560338b2",
              "68dfd0da7a9a1c12b5000ec2",
              "68dfd2c923d18ff3ea0307a2",
              "68dfd33749c4bf41860ef142",
              "68dfd16842d6c519830c7602",
              "68dfd196298f38cac10e24f2",
              "68dfd0120f9c5d585b02a4b2",
            ],
          },
        },
      });
    });
  };

  static getPromptTemplateById = (id) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/prompt-template/" + id;

      AxiosService.get(url, null, null)
        .then((result) => {
          const data = result.data || [];
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static createPrompt = (prompt) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/prompt";

      AxiosService.post(url, null, prompt, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static updatePrompt = (prompt) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/prompt/" + prompt.id;

      AxiosService.put(url, null, prompt, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static deletePrompt = (id) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/prompt/" + id;
      AxiosService.delete(url, null, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getAllFolders = () => {
    return new Promise(function (resolve, reject) {
      var url = "/api/folders";

      AxiosService.get(url, null, null)
        .then((result) => {
          const data = result.data || [];
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // static getAllHistory = (filter = {}, schoolId) => {
  //   return new Promise(function (resolve, reject) {
  //     var url = `/api/history/${schoolId}`;

  //     AxiosService.get(url, filter)
  //       .then((result) => {
  //         const data = result.data || [];
  //         resolve(data);
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // };

  static getAllHistory = async (filter = {}, schoolId) => {
    const url = `/api/history/${schoolId}`;
    const per_page = filter.per_page || 50;
    let allResults = [];
    let page = 1;
    let totalPages = 1;

    try {
      do {
        const params = { ...filter, page, per_page };
        const { data: responseData } = await AxiosService.get(url, params);

        // your API likely uses `data` for items
        const items = responseData?.data || [];
        allResults.push(...items);

        // detect total pages from `last_page`
        if (page === 1) totalPages = responseData.last_page || 1;

        page++;
      } while (page <= totalPages);

      return allResults;
    } catch (err) {
      console.error("Error fetching prompt categories:", err);
      throw err;
    }
  };

  static getHistoryById = (id, schoolId) => {
    return new Promise(function (resolve, reject) {
      const url = `/api/history/${schoolId}/${id}`;

      AxiosService.get(url, null, null)
        .then((result) => {
          const data = result.data || null;
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getHistoryDetail = (historyId) => {
    return new Promise((resolve, reject) => {
      const url = `/history/${historyId}/detail`;

      AxiosService.get(url)
        .then((result) => resolve(result))
        .catch((error) => reject(error));
    });
  };

  static createDetermina = (determina) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/create-determina";

      AxiosService.post(url, null, determina, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static createMessage = (message) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/message`;

      AxiosService.post(url, null, message, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static createHistory = (history) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/history`;

      AxiosService.post(url, null, history, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static updateHistory = (history_id, data, schoolId) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/history/${schoolId}/${history_id}`;

      AxiosService.put(url, null, data, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getAllMessages = async (filter = {}, schoolId) => {
    const url = `/api/message/${schoolId}`;
    const per_page = filter.per_page || 50;
    let allResults = [];
    let page = 1;
    let totalPages = 1;

    try {
      do {
        const params = { ...filter, page, per_page };
        const { data: responseData } = await AxiosService.get(url, params);

        // your API likely uses `data` for items
        const items = responseData?.data || [];
        allResults.push(...items);

        // detect total pages from `last_page`
        if (page === 1) totalPages = responseData.last_page || 1;

        page++;
      } while (page <= totalPages);

      return allResults;
    } catch (err) {
      console.error("Error fetching prompt categories:", err);
      throw err;
    }
  };

  // static getAllMessages = (filter = {}, schoolId) => {
  //   return new Promise(function (resolve, reject) {
  //     var url = `/api/message/${schoolId}`;

  //     AxiosService.get(url, filter)
  //       .then((result) => {
  //         const data = result.data || [];
  //         resolve(data);
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // };

  static getUserSavedMessage = (userId) => {
    return new Promise((resolve, reject) => {
      const url = `/messages/getUserSavedMessage/${userId}`;

      AxiosService.get(url)
        .then((result) => resolve(result))
        .catch((error) => reject(error));
    });
  };

  static updateMessages = (message, schoolId) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/message/${schoolId}/${message.id}`;

      AxiosService.put(url, null, message, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // Prompt Categories APIs
  static getAllPromptCategories = () => {
    return new Promise(function (resolve, reject) {
      var url = "/api/prompt-category";

      AxiosService.get(url, null, null)
        .then((result) => {
          const data = result.data || [];
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static createPromptCategory = (promptCat) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/prompt-category";

      AxiosService.post(url, null, promptCat, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static updatePromptCategory = (promptCat) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/prompt-category/" + promptCat.id;

      AxiosService.put(url, null, promptCat, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static deletePromptCategory = (id) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/prompt-category/" + id;
      AxiosService.delete(url, null, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getAllProducts = () => {
    return new Promise(function (resolve, reject) {
      var url = "/products";

      AxiosService.get(url, null, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getAllOrders = () => {
    return new Promise(function (resolve, reject) {
      var url = "/orders";

      AxiosService.get(url, null, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getPromptsWithMarketStatus = (isOnMarket) => {
    return new Promise(function (resolve, reject) {
      var url = "/prompts/market-status";
      var params = { isOnMarket: isOnMarket };

      AxiosService.get(url, params, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // Module APIs

  static getAllModules = () => {
    return new Promise(function (resolve, reject) {
      var url = "/api/module";

      AxiosService.get(url, null, null)
        .then((result) => {
          const data = result.data || [];
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getModuleById = (id) => {
    return new Promise(function (resolve, reject) {
      const url = `/api/module/${id}`;

      AxiosService.get(url, null, null)
        .then((result) => {
          const data = result.data || null;
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static createModule = (module) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/module";

      AxiosService.post(url, null, module, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static updateModule = (module) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/module/" + module.id;

      AxiosService.put(url, null, module, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static deleteModule = (id) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/module/" + id;
      AxiosService.delete(url, null, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getAllDepartments = (data = {}, schoolId) => {
    return new Promise(function (resolve, reject) {
      const queryString = new URLSearchParams(data).toString();
      const url = `/api/department/${schoolId}?${queryString}`;
      AxiosService.get(url, null, null)
        .then((result) => {
          const data = result.data || [];
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static createDepartment = (department) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/department`;

      AxiosService.post(url, null, department, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static updateDepartment = (department, schoolId) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/department/${schoolId}/${department.id}`;

      AxiosService.put(url, null, department, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static deleteDepartment = (id, schoolId) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/department/${schoolId}/${id}`;
      AxiosService.delete(url, null, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getClassRoomById = (id, schoolId) => {
    return new Promise(function (resolve, reject) {
      const url = `/api/department/${schoolId}/${id}`;

      AxiosService.get(url, null, null)
        .then((result) => {
          const data = result.data || null;
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getPromptById = (id) => {
    return new Promise(function (resolve, reject) {
      const url = `/api/prompt/${id}`;

      AxiosService.get(url, null, null)
        .then((result) => {
          const data = result.data || null;
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static getAllPromptTemplates = async (filter = {}) => {
    const url = "/api/prompt-template";
    const per_page = filter.per_page || 50;
    let allResults = [];
    let page = 1;
    let totalPages = 1;

    do {
      const params = { ...filter, page, per_page };
      const { data: responseData } = await AxiosService.get(url, params);

      const items = responseData?.data || [];
      allResults.push(...items);

      if (page === 1) totalPages = responseData.last_page || 1;

      page++;
    } while (page <= totalPages);

    return allResults;
  };

  // static getAllPromptTemplates = (filters = {}) => {
  //   return new Promise(function (resolve, reject) {
  //     var url = "/api/prompt-template";

  //     AxiosService.get(url, filters, null)
  //       .then((result) => {
  //         const data = result.data || [];
  //         resolve(data);
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // };

  static createPromptTemplate = (template) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/prompt-template";
      AxiosService.post(url, null, template, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static updatePromptTemplate = (template) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/prompt-template/" + template.id;

      AxiosService.put(url, null, template, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static deletePromptTemplate = (id) => {
    return new Promise(function (resolve, reject) {
      var url = "/api/prompt-template/" + id;
      AxiosService.delete(url, null, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // static getAllResources = (filter = {}, schoolId) => {
  //   return new Promise(function (resolve, reject) {
  //     const url = `/api/resources/${schoolId}`;

  //     AxiosService.get(url, filter)
  //       .then((result) => {
  //         const data = result.data || [];
  //         resolve(data);
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // };

  static getAllResources = async (filter = {}, schoolId) => {
    const url = `/api/resources/${schoolId}`;
    const per_page = filter.per_page || 50;
    let allResults = [];
    let page = 1;
    let totalPages = 1;

    try {
      do {
        const params = { ...filter, page, per_page };
        const { data: responseData } = await AxiosService.get(url, params);

        const items = responseData.data || [];
        allResults.push(...items);

        if (page === 1) totalPages = responseData.last_page || 1;

        page++;
      } while (page <= totalPages);

      return allResults;
    } catch (err) {
      console.error("Error fetching prompt categories:", err);
      throw err;
    }
  };

  static getResourceURL = (resource_id, schoolId) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/resources_surl/${schoolId}/${resource_id}`;
      AxiosService.get(url, null, null)
        .then((result) => {
          var data = result.data || null;
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static createResources = (formData) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/resources`;
      AxiosService.post(url, null, formData, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static updateResources = (school_id, resource_id, formData) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/resources/${school_id}/${resource_id}`;
      AxiosService.put(url, null, formData, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static deleteResources = (resource_id, schoolId) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/resources/${schoolId}/${resource_id}`;
      AxiosService.delete(url, null, null)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  //Stastics

  static getStastics = (schoolId, filter) => {
    return new Promise(function (resolve, reject) {
      var url = `/api/statistics/departments_daily/${schoolId}`;

      AxiosService.get(url, { ...filter, per_page: 50 }, null)
        .then((result) => {
          const data = result.data || [];
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
}
